module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-6.svg";